import { render, staticRenderFns } from "./BoardCreated.vue?vue&type=template&id=47b17155&scoped=true&"
import script from "./BoardCreated.vue?vue&type=script&lang=js&"
export * from "./BoardCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b17155",
  null
  
)

export default component.exports